import { RequiredUpdateScreen, WhatsNewNotice } from "@/app/pwa/UpdateNotices";
import { TelemetryObserver } from "@/app/telemetry/TelemetryObserver";
import { Outlet, useNavigation } from "react-router-dom";

/**
 * Provides the top-level application root container.
 * Tracks the visible viewport so expanded mobile browser controls do not create page overflow.
 * Uses the brand surface color (#E4F2FD) to seamlessly surround the mobile device frames.
 */
export function RootLayout() {
  const navigation = useNavigation();
  return (
    <div className="bg-brand-surface text-foreground min-h-dvh w-full">
      {navigation.state !== "idle" && (
        <p role="status" className="sr-only">
          در حال بارگذاری صفحه…
        </p>
      )}
      <TelemetryObserver />
      <Outlet />
      <RequiredUpdateScreen />
      <WhatsNewNotice />
    </div>
  );
}
